import APIRequest from './api';

export const GetNavigation = () => {
    return APIRequest({
        url: `Navigation/GetNavigation`,
        method: "get",
    });
}

